import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useParentsInfoChartsDataContext } from './hooks/useParentsInfoChartsDataContext';

export const MotherScholarity = () => {
    const { chartData } = useParentsInfoChartsDataContext();


    return (
        <SimpleBars
            title={'Escolaridade da Mãe'}
            horizontal={true}
            subtitles={chartData?.motherScholarity?.map((item) => item.description)}
            values={chartData?.motherScholarity?.map((item) => item.total  ||  0)}
        />
    );
};
